export default "__VITE_ASSET__Cilu$90U__"